function initialState () {
  return {
    showDrawer: null,
    mainMenu: [],
    mainMenuTitle: '',
    subnav: [],
    subnavTitle: '',
    extraNav: [],
    extraNavTitle: ''
  }
}
const state = initialState()

const actions = {
  loadMainMenu (context, menu) {
    context.commit('loadMainMenu', menu)
  },
  loadMainMenuTitle (context, menu) {
    context.commit('loadMainMenuTitle', menu)
  },
  clearMainMenu (context) {
    context.commit('clearMainMenu')
  },
  loadSubnav: function (context, menu) {
    context.commit('loadSubnav', menu)
  },
  loadSubnavTitle: function (context, title) {
    context.commit('loadSubnavTitle', title)
  },
  clearSubnav ({ commit }) {
    commit('clearSubnav')
  },
  loadExtraNav: function (context, menu) {
    context.commit('loadExtraNav', menu)
  },
  loadExtraNavTitle: function (context, title) {
    context.commit('loadExtraNavTitle', title)
  },
  clearExtraNav ({ commit }) {
    commit('clearExtraNav')
  },
  openDrawer ({ commit }) {
    commit('openDrawer')
  },
  closeDrawer ({ commit }) {
    commit('closeDrawer')
  },
  toggleDrawer ({ commit }) {
    commit('toggleDrawer')
  },
  setDrawer: function (context, val) {
    context.commit('setDrawer', val)
  },
  resetNav: function ({ commit }) {
    commit('resetNav')
  }
}

const mutations = {
  loadMainMenu (state, menu) {
    state.mainMenu = []
    state.mainMenu = menu
  },
  loadMainMenuTitle (state, menu) {
    state.mainMenuTitle = ''
    state.mainMenuTitle = menu
  },
  clearMainMenu (state) {
    state.mainMenu = [],
    state.mainMenuTitle = ''
  },
  loadSubnav (state, menu) {
    state.subnav = []
    state.subnav = menu
  },
  loadSubnavTitle (state, title) {
    state.subnavTitle = ''
    state.subnavTitle = title
  },
  clearSubnav (state) {
    state.subnavTitle = ''
    state.subnav = []
  },
  loadExtraNav (state, menu) {
    state.extraNav = menu
  },
  loadExtraNavTitle (state, title) {
    state.extraNavTitle = title
  },
  clearExtraNav (state) {
    state.extraNavTitle = ''
    state.extraNav = []
  },
  openDrawer (state) {
    state.showDrawer = true
  },
  closeDrawer (state) {
    state.showDrawer = false
  },
  toggleDrawer (state) {
    state.showDrawer = !state.showDrawer
  },
  setDrawer (state, val) {
    state.showDrawer = val
  },
  resetNav (state) {
    // acquire initial state
    const s = initialState()
    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  }
}

export default {
  state,
  actions,
  mutations
}
